<template>
    <div class="radial-menu-container" :class="{ 'menu-open': isOpen, 'loaded': menuLoaded, 'collapsed': !isOpen }">
      <svg class="menu" viewBox="-50 -50 100 100" width="400" height="400">
        <defs>
          <linearGradient id="hoverGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#ff7500" />
            <stop offset="100%" stop-color="#71bbc8" />
          </linearGradient>
        </defs>
        <g v-for="(item, index) in menuItems" :key="index" :transform="getTransform(index, menuItems.length)" 
           class="sector" :class="{ 'loading': menuLoaded && !sectorLoaded[index], 'collapsed': !isOpen }" @click.stop="selectItem(item)">
          <path :d="getSectorPath(index, menuItems.length)" />
          <text :x="getTextX(index, menuItems.length)" :y="getTextY(index, menuItems.length)"
                :transform="getTextRotation(index, menuItems.length)" text-anchor="middle" alignment-baseline="middle" font-size="3">
            <tspan v-for="(line, lineIndex) in splitText(item.label)" :key="lineIndex" :dy="lineIndex === 0 ? -3 : 4"
                   :dx="getTextDX(index, lineIndex)">
              {{ line }}
            </tspan>
          </text>
        </g>
        <!-- Center button for toggling the menu -->
        <g class="center">
          <circle cx="0" cy="0" r="19" @click="toggleMenu"></circle>
          <!-- Conditional rendering of Hamburger Icon or Question Mark -->
          <g class="hamburger-icon" v-if="isOpen" @click="toggleMenu">
            <line x1="-8" y1="-4" x2="8" y2="-4" stroke="white" stroke-width="2" />
            <line x1="-8" y1="0" x2="8" y2="0" stroke="white" stroke-width="2" />
            <line x1="-8" y1="4" x2="8" y2="4" stroke="white" stroke-width="2" />
          </g>
          <text v-else @click="toggleMenu" class="question-mark" x="0" y="5" text-anchor="middle" alignment-baseline="middle" fill="white" font-size="16">
            ?
          </text>
        </g>
      </svg>
    </div>
  </template>
  
  
  
  
  <script>
export default {
  data() {
    return {
      isOpen: true,  // Set the menu to be open by default
      selectedItem: null,
      menuItems: [
        { label: 'Building & Construction', link: '/building' },
        { label: 'Finance', link: '/finance' },
        { label: 'Legal', link: '/legal' },
        { label: 'Education & Training', link: '/education' },
        { label: 'Consulting & Marketing', link: '/consulting' },
        { label: 'Advertising', link: '/advertising' },
        { label: 'Contact Us', link: '/contact' },
      ],
      menuLoaded: false,
      sectorLoaded: Array(7).fill(false),
    };
  },
  mounted() {
    setTimeout(() => {
      this.menuLoaded = true;
      this.loadSectors();
    }, 100);
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;  // Toggle between open and collapsed states
    },
    selectItem(item) {
      this.selectedItem = item;
      console.log("Selected:", item);
      this.$router.push(item.link);
      if (item.label === 'Contact Us' || item.label === 'Advertising' || item.label === 'Building & Construction' || item.label === 'Legal' || item.label === 'Finance') { 
    this.isOpen = false; // Collapse the menu
}
    },
    splitText(text) {
      const maxLength = 12;
      const words = text.split(' ');
      const lines = [];
      let currentLine = '';
      words.forEach(word => {
        if (currentLine.length + word.length + 1 <= maxLength) {
          currentLine += currentLine.length > 0 ? ' ' + word : word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      });
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
      return lines;
    },
    loadSectors() {
      this.menuItems.forEach((_, index) => {
        setTimeout(() => {
          this.sectorLoaded[index] = true;
        }, index * 150);
      });
    },
    getSectorPath(index, totalItems) {
      const angle = (2 * Math.PI) / totalItems;
      const gapWidth = 2;
      const radius = 50;
      const startAngle = index * angle - Math.PI / 2;
      const endAngle = startAngle + angle;
      const innerRadius = 15;
      const outerRadius = radius - gapWidth;
      const x1 = outerRadius * Math.cos(startAngle);
      const y1 = outerRadius * Math.sin(startAngle);
      const x2 = outerRadius * Math.cos(endAngle);
      const y2 = outerRadius * Math.sin(endAngle);
      const innerX1 = innerRadius * Math.cos(startAngle);
      const innerY1 = innerRadius * Math.sin(startAngle);
      const innerX2 = innerRadius * Math.cos(endAngle);
      const innerY2 = innerRadius * Math.sin(endAngle);
      return `M ${innerX1} ${innerY1} L ${x1} ${y1} A ${outerRadius} ${outerRadius} 0 0 1 ${x2} ${y2} L ${innerX2} ${innerY2} A ${innerRadius} ${innerRadius} 0 0 0 ${innerX1} ${innerY1} Z`;
    },
    getTransform(index, totalItems) {
      return `rotate(${(360 / totalItems) * index})`;
    },
    getTextX(index, totalItems) {
      const angle = (2 * Math.PI) / totalItems;
      const midAngle = index * angle - Math.PI / 2 + angle / 4;
      return 35 * Math.cos(midAngle);
    },
    getTextY(index, totalItems) {
      const angle = (2 * Math.PI) / totalItems;
      const midAngle = index * angle - Math.PI / 2 + angle / 1.6;
      return 35 * Math.sin(midAngle);
    },
    getTextRotation(index, totalItems) {
      const angle = (360 / totalItems) * index;
      return `rotate(${-angle}, ${this.getTextX(index, totalItems)}, ${this.getTextY(index, totalItems)})`;
    },
    getTextDX(index, lineIndex) {
      return [6, -9, -3][lineIndex] || 0;
    }
  }
};
</script>

<style scoped>
.radial-menu-container {
  z-index: 10;
  bottom: 50px;
  right: 50px;
  width: 100%;
  /* height: 400px; */
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, width 0.3s, height 0.3s;
}

.menu-open {
  opacity: 1;
  visibility: visible;
}

.loaded {
  opacity: 1;
  visibility: visible;
}

.menu {
  width: 279%;
  height: 228%;
}

.sector path {
  background-image: linear-gradient(90deg, #ff7500, #71bbc8);
  fill: #ff6600;
  stroke: none;
  stroke-width: 2;
  transition: fill 0.2s ease-in-out, transform 0.3s;
  cursor: pointer;
}

.sector.loading path {
  fill: transparent;
  stroke: #aaa;
}

.sector:hover path {
  fill: url(#hoverGradient);
}

.sector.selected path {
  fill: #32CD32D0 !important;
}

/* Center button */
.center circle {
  fill: #222;
  cursor: pointer;
  transition: fill 0.2s;
  z-index: 2;  /* Ensure center circle stays above other content */
}

.center:hover circle {
  fill: #F9A602D0;
}

/* Ensure the question mark is visible even when collapsed */
.question-mark {
  font-size: 35px!important; /* Adjust size of question mark */
  font-weight: bold;
  cursor: pointer;
  fill: white; /* Make sure question mark is visible */
  opacity: 1 !important;
}

.hamburger-icon line {
  cursor: pointer;
}

.hamburger-icon {
  transform: translateY(1px); /* Slight adjustment to center the lines */
}

text {
  font-size: 3.5px;
  fill: white;
  transition: opacity 0.3s, font-size 0.3s;
}

/* Collapse sectors and text */
.collapsed .sector path {
  fill: transparent;
  transform: scale(0);
}

.collapsed text {
  opacity: 0;
  font-size: 0px;  /* Shrink the text */
}

/* Adjust the size of the container when collapsed */
.collapsed {
  width: 87px;
  height: 89px;
  display: flex; /* Ensure the center button is still in the middle */
  justify-content: center;
  align-items: center;
}

.collapsed .center {
  opacity: 1;  /* Ensure the center button (question mark or hamburger) stays visible */
}

/* Center button text size */
.center-text {
  font-size: 20px;
}

@media screen and (min-width: 769px) {
  .radial-menu-container {
    display: none;
  }
}
</style>
